import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FadeScrollWrapper } from '@app/styles';
import { AwaitModules, ComponentSync, LL_H_C, LL_V_L, scrollIntoView_Horizontal, TS_ButtonGroup } from '@nu-art/thunderstorm-frontend';
import { createRef } from 'react';
import { ModuleFE_PanelFindings } from '../../../../modules/ModuleFE_PanelFindings/ModuleFE_PanelFindings.js';
import { compare } from '@nu-art/ts-common';
import { generateChildrenLevelFindingViewButtons, generateTopLevelFindingViewButtons } from '../../../panels/AdvisorPanel_Findings/consts.js';
import { ModuleFE_Advisor_FindingView } from '@app/advisor-frontend';
import { Component_WizardIcon } from '../../advisor-wizard/Component_WizardIcon/Component_WizardIcon.js';
import './Component_FindingViews.scss';
import { Component_AdvisorSL_FindingViews } from '../../../loaders/skeleton/finding-views/Component_AdvisorSL_FindingViews.js';
const modulesToAwait = [
    ModuleFE_Advisor_FindingView,
];
class Component_FindingViews_Class extends ComponentSync {
    scrollRef_PrimaryViews = createRef();
    scrollRef_SecondaryViews = createRef();
    //######################### Life Cycle #########################
    __onFindingsContextUpdated = () => {
        this.reDeriveState();
    };
    deriveStateFromProps(nextProps, state) {
        const panelState = ModuleFE_PanelFindings.getFindingsPanelState();
        state.selectedViewIds = {
            parent: panelState.selectedParentViewId,
            child: panelState.parentViewData[panelState.selectedParentViewId]?.selectedChildViewId,
        };
        state.parentViewButtons ??= generateTopLevelFindingViewButtons();
        if (!state.childViewButtons || state.selectedViewIds.parent !== this.state?.selectedViewIds.parent)
            state.childViewButtons = generateChildrenLevelFindingViewButtons(state.selectedViewIds.parent);
        return state;
    }
    componentDidUpdate(prevProps, prevState) {
        if (compare(prevState.selectedViewIds, this.state.selectedViewIds))
            return;
        // make sure both finding views are presented on screen properly in case of scroll
        this.scrollToFindingView(this.state.selectedViewIds.parent, this.scrollRef_PrimaryViews);
        if (this.state.selectedViewIds.child)
            this.scrollToFindingView(this.state.selectedViewIds.child, this.scrollRef_SecondaryViews);
    }
    //######################### Logic #########################
    scrollToFindingView = (selectedId, scrollLRef) => {
        const button = document.getElementById(`button-${selectedId}`);
        if (!button) {
            this.logWarning('Button not found for id', selectedId);
            return;
        }
        scrollIntoView_Horizontal(button, scrollLRef, 'smooth');
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { className: 'c__finding-views', children: [this.render_Primary(), _jsxs(LL_H_C, { className: 'c__finding-views-sub', children: [this.render_Secondary(), this.render_Wizard()] })] });
    }
    render_Primary = () => {
        return _jsx(FadeScrollWrapper, { scrollRef: this.scrollRef_PrimaryViews, direction: 'horizontal', className: 'c__finding-views__primary', children: _jsx(TS_ButtonGroup, { controlled: true, direction: 'horizontal', buttons: this.state.parentViewButtons, selectedKey: this.state.selectedViewIds.parent, clickCallback: key => ModuleFE_PanelFindings.setSelectedParentView(key) }) });
    };
    render_Secondary = () => {
        if (!this.state.childViewButtons?.length)
            return;
        return _jsx(FadeScrollWrapper, { scrollRef: this.scrollRef_SecondaryViews, direction: 'horizontal', children: _jsx(TS_ButtonGroup, { controlled: true, direction: 'horizontal', buttons: this.state.childViewButtons, selectedKey: this.state.selectedViewIds.child, clickCallback: key => ModuleFE_PanelFindings.setSelectedChildView(key) }) });
    };
    render_Wizard = () => {
        const fvId = this.state.selectedViewIds.child ?? this.state.selectedViewIds.parent;
        const fv = ModuleFE_Advisor_FindingView.cache.unique(fvId);
        if (!fv?.wizardId)
            return;
        return _jsx(Component_WizardIcon, { wizardFilter: w => w._id === fv.wizardId }, fv.wizardId);
    };
}
export const Component_FindingViews = (p) => _jsx(AwaitModules, { modules: modulesToAwait, Component: () => _jsx(Component_FindingViews_Class, { ...p }), customLoader: Component_AdvisorSL_FindingViews });
//# sourceMappingURL=Component_FindingViews.js.map